/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAsin } from '../../factoriesAny.js';
export var asinDependencies = {
  ComplexDependencies,
  typedDependencies,
  createAsin
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesAsin.generated.js
// module id = null
// module chunks = 